import { creatureText } from '../../shared/game-config.ts';
import { applyCreatureTexts } from '../common/creature-texts.ts';

/** Titre et textes fixes de la page du jeu, d'après le nom des créatures. */
export function applyGameTexts(): void {
  document.title = creatureText('Pocket {Monstres}');
  applyCreatureTexts();
}
